import { useUserStore } from '@/stores/userStore';
import { enableQuasarCSS } from '@/utils/quasar';
// import HomePage from '@/pages/prelogin/HomePage.vue';
const requirePage = require.context('@/pages/prelogin/static', false, /\.vue$/);
const routes = 
[
    {
        path: '/',
        name: 'PreloginHome',
        component: () => import('@/pages/prelogin/HomePage.vue'),
    },
    {
        path: '/products',
        name: 'Products',
        component: () => import('@/pages/prelogin/ProductListing.vue'),
    },
    {
        path: '/products/search/:search',
        name: 'Search Products',
        component: () => import('@/pages/prelogin/ProductListing.vue'),
    },
    {
        path: '/blogs',
        name: 'Blogs Listing',
        component: () => import('@/pages/prelogin/Blogs.vue'),
    },
    {
        path: 'blog/preview/:slug',
        name: 'PreviewBlog',
        component: () => import('@/pages/admin/blog/PreviewBlog.vue'),
        meta: { requiresAuth: true },
        props: true,
    },
    {
        path: '/blog/:slug',
        name: 'Blog',
        component: () => import('@/pages/prelogin/Blog.vue'),
    },
    {
        path: '/products/:catName',
        name: 'Category Product Listing',
        component: () => import('@/pages/prelogin/ProductListing.vue'),
    },
    {
        path: '/product/:url_path',
        name: 'Product Details',
        beforeEnter: (to, from, next) => {
            enableQuasarCSS();
            next();
        },
        component: () => import('@/pages/prelogin/ProductDetails.vue'),
    },
    {
        path: '/find-an-advisor',
        name: 'Wellness Advisor Form',
        component: () => import('@/pages/prelogin/WellnessAdvocateForm.vue'),
    },
    {
        path: '/category/:slug',  // Matches the specific slugs
        name: 'Category Page',
        component: ()=>import('@/pages/prelogin/CategoryDetail.vue'),
    },
    {
        path: '/thankyou',
        name: 'Thankyou',
        component: () => import('@/components/prelogin/ThankYou.vue'),
    },
    {
        path: '/testimonials',
        name: 'Testimonials',
        component: () => import('@/pages/prelogin/Testimonials.vue'),
    },
    {
        path: '/forgot-password',
        name: 'Forgot Password',
        component: () => import('@/pages/prelogin/Forgot-Password.vue'),
    },
    {
        path: '/coming-soon',  
        name: 'Coming Soon',
        component:() => import('@/pages/prelogin/static/coming-soon.vue'),
    },
    {
        path: '/our-story',
        name: 'Our Story',
        component: () => import('@/pages/prelogin/AboutUs.vue'),
    },
    {
        path: '/faq',
        name: 'Faq',
        component: () => import('@/pages/prelogin/faq.vue'),
    },
    {
        path: '/resources',
        name: 'Resources',
        component: () => import('@/pages/prelogin/Resources.vue'),
    },
    {
        path: 'payment/success/:txnId',  
        name: 'PaymentSuccess ',
        component:() => import('@/pages/postlogin/PaymentSuccess.vue'),
    },
    {
        path: 'payment/failure/:txnId',  
        name: 'PaymentFailure ',
        component:() => import('@/pages/postlogin/PaymentFailure.vue'),
    },
    {
        path: 'cart',  
        name: 'CartComponent ',
        component:() => import('@/pages/postlogin/MyCart.vue'),
    },
    {
        path: 'checkout',  
        name: 'CheckOut ',
        component:() => {
            const userStore = useUserStore();
            if (!userStore.isLoggedIn) {
              return import('@/pages/prelogin/Checkout.vue') // Load component if logged in
            } else {
              return import('@/pages/postlogin/Checkout.vue') // No component if not logged in
            }
        },
    },
    {
        path: 'first-order',  
        name: 'FirstOrder ',
        component:() => import('@/pages/prelogin/FirstOrder.vue'),
    },
    {
        path: 'infinite',  
        name: 'Infinite ',
        component:() => import('@/components/common/InfiniteScroll.vue'),
    },
    {
        path: '/register',
        name: 'Final Registration',
        component: () => import('@/pages/prelogin/Register.vue'),
        // beforeEnter: (to, from, next) => {
            // loadQuasarCSS().then(() => {
                // removeQuasarCSS(); // Ensure Quasar CSS is removed before entering the route
                // next();
                // });
            // },
        meta: { requiresAuth: true },
    },
    
];

requirePage.keys().forEach(fileName => {
  const componentName = fileName
    .replace(/^\.\//, '')  // Remove the leading './'
    .replace(/\.\w+$/, ''); // Remove the file extension

  const routePath = `/${componentName.toLowerCase()}`;

  // Check if a route with the same path or name is already defined
  if (!routes.find(route => route.path === routePath || route.name.toLowerCase() === componentName.toLowerCase())) {
    routes.push({
      path: routePath,
      name: componentName,
      component: requirePage(fileName).default,
    });
  }
});
export default [
    {
        path: '/',
        component: () => import('@/layouts/LayoutWrapper.vue'),
        children: routes,
    },
];